<template>
  <button
    class="w-12 h-12 inline-flex items-center justify-center cursor-pointer"
    style="margin: 0px 0px 0px 1px;"
    :class="classes"
    @mousedown="toggle"
    @keydown.space="toggle"
  ></button>
</template>

<script>
export default {
  name: 'Note',
  props: {
    note: Object,
    offset: Number,
  },
  computed: {
    classes() {
      const { on, offset } = this.note;
      return [
        on ? 'bg-blue-300' : '',
        offset % 2 === 0 ? 'even-note' : 'odd-note',
      ];
    },
  },
  methods: {
    toggle() {
      this.$emit('toggle', this.note);
    },
  },
};
</script>
